import SaveProspectoPymes from "../../shared/componente/save_prospecto_pymes/SaveProspectoPymes"

export default function CreateProspectoPymesPage() {

  return <SaveProspectoPymes
    titulo="Prospecto PYMES"
  />

}